module.exports = __webpack_public_path__ + "static/landing-background-e16090e5472acb89b778e707131aa6b4.png";